import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import LoadingScreen from "./LoadingScreen";
import api from "../core/api";

export default function GuestGuard({ children }) {
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let cancelled = false;

    async function checkAuth() {
      if (!localStorage.getItem("token")) {
        if (!cancelled) setStatus("guest");
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        if (data?.user && data.success !== false) {
          localStorage.setItem("user", JSON.stringify(data.user));
          if (!cancelled) setStatus("authed");
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          if (!cancelled) setStatus("guest");
        }
      } catch {
        if (!cancelled) setStatus("guest");
      }
    }

    checkAuth();
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === "loading") return <LoadingScreen message="در حال بررسی وضعیت ورود..." />;
  if (status === "authed") return <Navigate to="/dashboard" replace />;
  return children;
}
